require([
  'widget-initializer',
  'views/base',
  'views/logo-view',
  'views/product-list-view',
  'views/product-block-view',
  'views/product-view',
  'views/cart-page-view',
  'views/payment-page-view',
  'views/page-sidebar-controller',
  'views/reset-password',
  'views/profile-info',
  'views/offer-page-view',
  'views/order-page-view',
  'views/draft-page-view',
  'views/news-listing-view',
  'views/mypage-view',
  'views/customer-logo-view',
  'views/reseller-locator-controller',
  'views/quick-add-view',
  'views/customized-pdf-view',
  'views/user-import',
  'views/reseller-map-locator',
  'views/newsletter-subscribe-block-view',
  'views/microshop-page-view',
  'views/microshop-orders-view',
  'views/microshop-master-order-view',
  'views/microshop-shops-view',

  'libs/respond/respond',
  'utils/bind-manager',
  'utils/rivets-binders'
], function (
  widgets,
  baseView,
  logoView,
  productListing,
  productBlock,
  productView,
  cartView,
  paymentpageview,
  pageSidebar,
  resetPasswordView,
  profileInfoView,
  offerView,
  orderView,
  draftView,
  myNewsListingView,
  myPageView,
  customerLogoView,
  resellerLocator,
  quickAddView,
  customizedPdfView,
  userImport,
  resellerMapLocator,
  newsletterSubscribeView,
  microshopPageView,
  microshopOrdersView,
  microshopMasterOrderView,
  MicroshopShopsView,
  respond,
  bindMng
) {
  // Initialize all widgets
  widgets.init();

  baseView.call();
  productListing.call();
  productView.call();
  productBlock.call();
  logoView.call();
  cartView.call();
  pageSidebar.call();
  resetPasswordView.call();
  profileInfoView.call();
  offerView.call();
  orderView.call();
  draftView.call();
  myNewsListingView.call();
  myPageView.call();
  customerLogoView.call();
  resellerLocator.call();
  quickAddView.call();
  customizedPdfView.call();
  userImport.call();
  resellerMapLocator.call();
  newsletterSubscribeView.call();
  microshopPageView.call();
  microshopOrdersView.call();
  microshopMasterOrderView.call();
  MicroshopShopsView.call();
  paymentpageview.call();
  respond.watchResize();
  respond.run();
  bindMng.rebind();
});

define("main", function(){});

